import { Injectable } from '@angular/core';
import {environment} from 'environments/environment'
import {Headers, Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import { saveAs } from 'file-saver/FileSaver';

@Injectable()
export class WarningInspection {
  headers: Headers;
  url = environment.qrcode_url;
  constructor(
    private http: Http,
    private apiEvsService: ApiEvsService
  )
  {
    const token  = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }
  getList(query?: any): Observable<any> {
    return this.http.get(`${this.url}/market-inspection`, {headers: this.headers, params: query}).map(res => {
      return res.json()
    }).catch((error: any) => {
      throw error.json();
    });
  }

   // Export logs
   public getTokenDownloadInspection(query){
    return this.apiEvsService.getExcel2('/qr_aps/market-inspection/export', query)
  }

  public saveToFileSystem(response, __type, filename) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');

    if (contentDispositionHeader !== null) {
      const parts: string[] = contentDispositionHeader.split(';');
      //const filename = parts[1].split('=')[1];
      const blob = new Blob([response._body], { type: __type });
      console.log(111, blob)
      saveAs(blob, filename);
    } else {
      // handling download condition if content disposition is empty
      const blob = new Blob([response._body], { type: __type });
      console.log(222, blob)

      saveAs(blob, filename);
    }

  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/warning-overflow/services/warning-inspection.ts